import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { ToastContainer } from 'react-toastify';
import ProtectedRoute from './routes/ProtectedRoute';
import Login from './pages/login';
import Scan from './pages/scan'
import ScanDetails from './pages/scanDetails'
import ReviewHistory from './pages/reviewHistory';
import ScanFiles from './pages/scanFiles';

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Login />
              </ProtectedRoute>
            }
          />

          <Route
            path="/scans"
            element={
              <ProtectedRoute>
                <Scan />
              </ProtectedRoute>
            }
          />

          <Route
            path="/reviewHistory"
            element={
              <ProtectedRoute>
                <ReviewHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/scan/:id"
            element={
              <ProtectedRoute>
                <ScanDetails />
              </ProtectedRoute>
            }
          />

          <Route path="/scan-files" element={<ProtectedRoute><ScanFiles /></ProtectedRoute>} />

          {/* Public route */}
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
